export default __webpack_public_path__ + "static/media/Darkblade's Robe of the Emissary.a12808ff.jpg";